import React from 'react';
import { FadeIn, Button } from './ui';
export const Offer = () => {
  return <section className="py-24 px-6 relative overflow-hidden" data-id="element-102">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber/5 blur-[120px] rounded-full pointer-events-none" data-id="element-103"></div>

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-104">
        <FadeIn data-id="element-105">
          <h2 className="text-4xl md:text-5xl mb-8 text-balance" data-id="element-106">
            Reclaim your nights.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-107">
          <p className="text-lg text-parchment-muted font-light leading-relaxed mb-10 max-w-lg mx-auto" data-id="element-108">
            Less than the cost of a large pizza. No subscriptions, no expensive
            supplements, no "sleep retreats." Just a manual override for your
            brain.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-109">
          <div className="mb-10" data-id="element-110">
            <span className="font-serif text-5xl text-amber" data-id="element-111">$6.99</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-112">
          <div className="flex flex-col items-center gap-4" data-id="element-113">
            <Button className="text-lg px-10 py-5 w-full md:w-auto" data-id="element-114">
              Get The 3AM Mind-Quiet Script Now
            </Button>
            <p className="text-sm text-parchment-dark font-light tracking-wide uppercase" data-id="element-115">
              Instant PDF Download • Start tonight
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};